import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { adicionarMembroSchema, type AdicionarMembroFormData } from "../components/form/schemas"
import { mapAdicionarMembroFormToPayload } from "../helpers/gestao-equipe-helpers"
import { useCreateContract } from "@/services/queries/useContratos"

export function useGestaoEquipeForm(projetoId: number, onSucess?: () => void) {

  const form = useForm<AdicionarMembroFormData>({
    resolver: zodResolver(adicionarMembroSchema),
    defaultValues: {
      name: "",
      pj_name: "",
      email: "",
      document: "",
      pj_document: "",
      role: "",
    },
  })

  const { mutateAsync: register, isPending } = useCreateContract()

  const onSubmit = async (data: AdicionarMembroFormData) => {
    const payloadRegister = mapAdicionarMembroFormToPayload(projetoId, data)
    await register(payloadRegister)

    if (onSucess) {
      onSucess()
    }
  }

  return {
    form,
    isPending,
    onSubmit,
  }
}
